<template>
  <v-container fluid class="pa-4 grey lighten-5">
    <!-- Header Section -->

    <!-- Metrics Metrics Dynamic Summary Cards -->
    <v-row class="mt-n2 mb-2">
      <!-- Total Deposits -->
      <v-col cols="12" md="4">
        <v-card
          class="rounded-xl elevation-2 summary-card success--text"
          outlined
        >
          <v-card-text class="d-flex align-center justify-between pa-4">
            <div>
              <div
                class="text-overline text-uppercase success--text opacity-70"
              >
                Total Deposits
              </div>
              <div class="text-h4 font-weight-bold success--text">
                {{ formatCurrency(summary?.totalDeposit || 0) }}
              </div>
            </div>
            <v-icon size="48" color="green" class="opacity-30"
              >mdi-arrow-down-bold-circle-outline</v-icon
            >
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Total Withdrawals -->
      <v-col cols="12" md="4">
        <v-card
          class="rounded-xl elevation-2 summary-card error--text"
          outlined
        >
          <v-card-text class="d-flex align-center justify-between pa-4">
            <div>
              <div class="text-overline text-uppercase error--text opacity-70">
                Total Withdrawals
              </div>
              <div class="text-h4 font-weight-bold error--text">
                {{ formatCurrency(summary?.totalWithdrawal || 0) }}
              </div>
            </div>
            <v-icon size="48" color="red" class="opacity-30"
              >mdi-arrow-up-bold-circle-outline</v-icon
            >
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Current Running Trust Balance -->
      <v-col cols="12" md="4">
        <v-card class="rounded-xl elevation-2 summary-card primary--text">
          <v-card-text class="d-flex align-center justify-between pa-4">
            <div>
              <div
                class="text-overline text-uppercase primary--text opacity-70"
              >
                {{ getTrustAccLabel }} Balance
              </div>
              <div class="text-h4 font-weight-bold primary--text">
                {{ formatCurrency(summary?.runningBalance || 0) }}
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30"
              >mdi-scale-balance</v-icon
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Data Table Ledger -->
    <v-card class="rounded-xl elevation-2 overflow-hidden">
      <v-card-title class="white pa-4 d-flex flex-wrap align-center">
        <v-icon left color="blue-grey darken-3"
          >mdi-format-list-bulleted</v-icon
        >
        <span class="font-weight-bold blue-grey--text text--darken-3"
          >Transaction History</span
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="scope === 'case'"
          dark
          outlined
          color="teal"
          class="mr-2 elevation-2 modern-btn"
          @click="openTransactionDialog('Deposit')"
        >
          <v-icon left>mdi-cash-plus</v-icon> Deposit
        </v-btn>
        <v-btn
          v-if="scope === 'case'"
          outlined
          color="error"
          class="elevation-2 modern-btn mr-1"
          @click="openTransactionDialog('Withdrawal')"
        >
          <v-icon left>mdi-cash-minus</v-icon> Withdraw
        </v-btn>

        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search description, reference, or invoice..."
          single-line
          hide-details
          outlined
          dense
          class="max-width-search mt-2 mt-sm-0"
        ></v-text-field> -->
      </v-card-title>

      <CrudEditableTable
        table="trust_account_ledger"
        :moneyColumns="['amount', 'running_balance']"
        :hiddenColumns="['user_id', 'client_reference']"
        :mode="isAdmin"
        :whereCol="ledgerRefField"
        :whereVal="ledgerRefValue"
        :showAddButton="false"
      />

      <!-- <v-data-table
          :headers="headers"
          :items="summary?.transactions"
          :search="search"
          :loading="loading"
          loading-text="Loading ledger rows... please wait"
          class="modern-table"
          :items-per-page="10"
        >
          
          <template v-slot:item.type="{ item }">
            <v-chip
              :color="item.type === 'Deposit' ? 'green lighten-5 green--text text--darken-3' : 'red lighten-5 red--text text--darken-3'"
              class="font-weight-bold px-3"
              small
            >
              <v-icon left small :color="item.type === 'Deposit' ? 'green darken-3' : 'red darken-3'">
                {{ item.type === 'Deposit' ? 'mdi-plus-circle' : 'mdi-minus-circle' }}
              </v-icon>
              {{ item.type }}
            </v-chip>
          </template>
  
         
          <template v-slot:item.amount="{ item }">
            <span :class="item.type === 'Deposit' ? 'green--text text--darken-2 font-weight-bold' : 'red--text text--darken-2 font-weight-bold'">
              {{ item.type === 'Deposit' ? '+' : '-' }} {{ formatCurrency(item.amount) }}
            </span>
          </template>
  
          <template v-slot:item.running_balance="{ item }">
            <span class="font-weight-medium grey--text text--darken-3">
              {{ formatCurrency(item.running_balance) }}
            </span>
          </template>
  
          <template v-slot:item.transaction_at="{ item }">
            {{ formatDate(item.transaction_at) }}
          </template>
  
         
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="blue-grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="openEditDialog(item)"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit References</span>
            </v-tooltip>
          </template>
        </v-data-table> -->
    </v-card>

    <!-- Global Processing Dialog Formulation (Deposit / Withdrawal) -->
    <v-dialog
      v-model="transactionDialog"
      max-width="600px"
      persistent
      class="rounded-xl"
    >
      <v-card class="rounded-xl">
        <v-card-title
          :class="
            dialogMode === 'Deposit'
              ? 'success white--text pa-4'
              : 'error white--text pa-4'
          "
        >
          <v-icon left dark>{{
            dialogMode === "Deposit" ? "mdi-cash-plus" : "mdi-cash-minus"
          }}</v-icon>
          <span class="text-h6 font-weight-bold"
            >Record {{ getTrustAccLabel }} {{ dialogMode }}</span
          >
        </v-card-title>

        <v-card-text class="pt-6">
          <v-form ref="transactionForm" v-model="isFormValid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model.number="form.amount"
                  :label="`Amount (${getCurrency})`"
                  type="number"
                  :prefix="getCurrency"
                  outlined
                  dense
                  :rules="[
                    (v) => !!v || 'Amount is required',
                    (v) => v > 0 || 'Must be greater than 0',
                  ]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="form.payment_method"
                  :items="['EFT', 'Card', 'Cash', 'Cheque']"
                  label="Payment Method"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.client_reference"
                  :label="`${matterLabel} Reference`"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="transactionReference"
                  :label="`${matterLabel} Internal Ref`"
                  outlined
                  dense
                  :required="scope === 'case'"
                  :disabled="scope === 'case'"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12">
                  <v-text-field
                    v-model="form.invoice_no"
                    label="Invoice Number [Optional]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col> -->
              <v-col cols="12">
                <v-textarea
                  v-model="form.description"
                  label="Transaction Description / Allocation Details"
                  outlined
                  dense
                  rows="3"
                  counter="500"
                  :rules="descriptionRules"
                  required
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4 grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="closeTransactionDialog"
            >Cancel</v-btn
          >
          <v-btn
            :color="dialogMode === 'Deposit' ? 'success' : 'error'"
            :disabled="!isFormValid"
            :loading="submitting"
            @click="submitTransaction"
            class="px-4"
          >
            Confirm {{ dialogMode }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Metadata Update Dialog Frame -->
    <v-dialog v-model="editDialog" max-width="500px" persistent>
      <v-card class="rounded-xl">
        <v-card-title class="blue-grey darken-3 white--text pa-4">
          <v-icon left dark>mdi-pencil</v-icon>
          <span class="text-h6 font-weight-bold">Update References</span>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="editForm">
            <v-select
              v-model="editFormFields.payment_method"
              :items="['EFT', 'Card', 'Cash', 'Cheque']"
              label="Payment Method"
              outlined
              dense
            ></v-select>
            <v-text-field
              v-model="editFormFields.invoice_no"
              label="Invoice Number Link"
              outlined
              readonly
              dense
            ></v-text-field>
            <v-textarea
              v-model="editFormFields.description"
              label="Description / Audit Notes"
              outlined
              dense
              rows="3"
              counter="500"
              :rules="[(v) => !!v || 'Description details are required']"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4 grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="editDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" :loading="submitting" @click="submitUpdate"
            >Save Changes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";
import CrudEditableTable from "@/modules/CrudDatabases/CrudEditableTable.vue";

export default {
  name: "TrustAccountLedger",
  components: {
    CrudEditableTable,
  },
  props: {
    // Strategy evaluation context: must pass either 'client' or 'case'
    scope: {
      type: String,
      required: true,
      validator: (value) => ["client", "case"].includes(value),
    },
    // The query string tracking key index identifier value
    reference: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ledgerRefField: null,
    ledgerRefValue: null,
    search: "",
    loading: false,
    submitting: false,
    transactionDialog: false,
    editDialog: false,
    dialogMode: "Deposit", // Deposit | Withdrawal
    isFormValid: true,
    activeSelectedId: null,
    summary: {
      totalDeposit: 0.0,
      totalWithdrawal: 0.0,
      runningBalance: 0.0,
      transactions: [],
    },
    form: {
      amount: 0,
      payment_method: "EFT",
      client_reference: "",
      case_internal_ref: "",
      invoice_no: "",
      description: "",
    },
    editFormFields: {
      payment_method: "",
      invoice_no: "",
      description: "",
    },
    headers: [
      {
        text: "Edit",
        value: "actions",
        align: "center",
        sortable: false,
        width: "70px",
      },
      { text: "Date", value: "transaction_at", sortable: true, width: "150px" },
      { text: "Type", value: "type", sortable: false, width: "120px" },
      { text: "Allocation Detail", value: "description", sortable: false },
      {
        text: "Method",
        value: "payment_method",
        sortable: true,
        width: "110px",
      },
      {
        text: "Linked Invoice",
        value: "invoice_no",
        sortable: true,
        width: "140px",
      },
      {
        text: "Amount",
        value: "amount",
        align: "end",
        sortable: true,
        width: "130px",
      },
      {
        text: "Balance Tracking",
        value: "running_balance",
        align: "end",
        sortable: false,
        width: "140px",
      },
    ],
  }),
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    matterLabel() {
      return "Account";
    },
    getTrustAccLabel() {
      return this.$store.getters.getTrustAccLabel;
    },
    scopeLabel() {
      return this.scope === "client" ? "Client" : this.matterLabel;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getAppMode() {
      return this.$store.getters.getAppMode;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    descriptionRules() {
      const rules = [(v) => !!v || "Description is required"];
      if (this.dialogMode === "Withdrawal") {
        rules.push(
          (v) =>
            (v && v.length >= 2) ||
            "Withdrawals strictly require a description."
        );
      }
      return rules;
    },

    transactionReference: {
      get() {
        return this.appMode === "legal"
          ? this.form.case_internal_ref
          : this.form.invoice_no;
      },
      set(val) {
        if (this.appMode === "legal") {
          this.form.case_internal_ref = val;
        } else {
          this.form.invoice_no = val;
        }
      },
    },
  },
  watch: {
    reference: {
      immediate: true,
      handler: "fetchLedgerData",
    },
  },
  methods: {
    //done
    capitalizeFirstCharacter(str) {
      return helpersJs.capitalizeFirstCharacter(str);
    },
    //done
    async fetchLedgerData() {
      if (!this.reference || !this.scope) return;
      this.loading = true;

      const endpoint = `/auth/get-${this.scope}-statement`;
      let data = { mode: this.getAppMode };

      this.ledgerRefValue = this.reference;

      if (this.scope === "client") {
        data["clientReference"] = this.reference;
        this.ledgerRefField = "client_reference";
      } else if (this.scope === "case") {
        data["caseInternalRef"] = this.reference;
        this.ledgerRefField = "invoice_no";
      } else {
        return;
      }

      if (!data) return;

      try {
        const response = await axios.postDataWithToken(
          endpoint,
          data,
          this.getAccessToken
        );

        this.summary = response;
      } catch (error) {
        this.$toast.error("Failed to pull ledger data packets.", "error");
      } finally {
        this.loading = false;
      }
    },
    //done
    openTransactionDialog(mode) {
      this.dialogMode = mode;
      this.form = {
        amount: null,
        payment_method: "EFT",
        client_reference: this.scope === "client" ? this.reference : "",
        case_internal_ref:
          this.scope === "case" && this.getAppMode === "legal"
            ? this.reference
            : "",
        invoice_no: this.getAppMode === "general" ? this.reference : "",
        description: "",
      };

      this.transactionDialog = true;
      this.$nextTick(() => {
        if (this.$refs.transactionForm)
          this.$refs.transactionForm.resetValidation();
      });
    },
    //done
    closeTransactionDialog() {
      this.transactionDialog = false;
    },
    //done
    async submitTransaction() {
      if (!this.$refs.transactionForm.validate()) return;

      try {
        const endpoint = this.dialogMode.toLowerCase(); // 'deposit' or 'withdrawal'
        const response = await axios.postDataWithToken(
          `/auth/${endpoint}`,
          this.form,
          this.getAccessToken
        );

        if (response?.data?.success) {
          this.$toast.success(response.message);
          this.transactionDialog = false;
          await this.fetchLedgerData();
        }
      } catch (error) {
        this.$toast.error(
          error.response?.data?.error || "Transaction rejected.",
          "error"
        );
      } finally {
        this.submitting = false;
      }
    },
    //done
    openEditDialog(item) {
      this.activeSelectedId = item.id;
      this.editFormFields = {
        payment_method: item.payment_method,
        invoice_no: item.invoice_no || "",
        description: item.description,
      };
      this.editDialog = true;
    },
    //done
    async submitUpdate() {
      if (!this.$refs.editForm.validate()) return;
      this.submitting = true;
      this.editFormFields.id = this.activeSelectedId;

      try {
        await axios.postDataWithToken(
          `/auth/update`,
          this.editFormFields,
          this.getAccessToken
        );
        this.$toast.success("Data updated successfully.");
        this.editDialog = false;
        await this.fetchLedgerData();
      } catch (error) {
        this.$toast.error("Update failed.");
      } finally {
        this.submitting = false;
      }
    },
    //done
    formatCurrency(value) {
      return this.getCurrency + " " + helpersJs.formatMoney(value);
    },
    //done
    formatDate(dateString) {
      if (!dateString) return "N/A";
      return new Date(dateString).toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
/* Advanced Premium Card Layout Gradients */
.gradient-deposit {
  background: linear-gradient(135deg, #2e4c2f 0%, #aec5b0 100%) !important;
}
.gradient-withdraw {
  background: linear-gradient(135deg, #722c2c 0%, #9a7776 100%) !important;
}
.gradient-balance {
  background: linear-gradient(135deg, #37474f 0%, #607d8b 100%) !important;
}

.summary-card {
  transition: transform 0.2s ease;
}
.summary-card:hover {
  transform: translateY(-2px);
}

.max-width-search {
  max-width: 340px;
}

.opacity-70 {
  opacity: 0.7;
}
.opacity-30 {
  opacity: 0.3;
}
.d-flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.text-white {
  color: white !important;
}

/* Custom Overrides for Modern Table Presentations */
.modern-table >>> th {
  background-color: #f8f9fa !important;
  font-weight: 700 !important;
  color: #37474f !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  letter-spacing: 0.5px;
}

.modern-btn {
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  border-radius: 8px;
}
</style>
